export const healthcareManagementConst = {
  path: "/single-programs/healthcare-management",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — МЕНЕДЖМЕНТ В ЗДРАВООХРАНЕНИИ (по направлениям)",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <br />
      <p>
        Менеджмент в здравоохранении — это современная программа подготовки управленцев в сфере медицины. Обучение направлено на
        формирование стратегического и операционного мышления, понимание медицинской экономики, страховых моделей, управления качеством и
        безопасности пациентов.
      </p>
      <p>
        Программа охватывает такие направления, как организация работы клиник и госпиталей, медицинский маркетинг, HR в здравоохранении,
        правовые аспекты и цифровая трансформация медицинских учреждений. Студенты осваивают навыки аналитики, финансового планирования и
        построения эффективных систем здравоохранения в условиях реформ и международных стандартов.
      </p>
      <h2>Кем можно работать:</h2>
      <ul>
        <li>Руководитель медицинского учреждения</li>
        <li>Менеджер по качеству медицинских услуг</li>
        <li>Администратор клиники</li>
        <li>Эксперт в системе обязательного медицинского страхования (ОМС)</li>
        <li>Консультант по медицинской экономике и организационным изменениям</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€50,000 до €100,000 в год</strong>
      </p>
      <p>в зависимости от должности, страны и уровня учреждения</p>
      <h2>Как поступить?</h2>
      <p>Узнайте подробности о стоимости и условиях — оставьте заявку на консультацию!</p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очно или дистанционно
    Форма: Получить консультацию приемной комиссии
    Менеджмент в здравоохранении — это современная программа подготовки управленцев в сфере медицины. Обучение направлено на формирование стратегического и операционного мышления, понимание медицинской экономики, страховых моделей, управления качеством и безопасности пациентов.
    Программа охватывает такие направления, как организация работы клиник и госпиталей, медицинский маркетинг, HR в здравоохранении, правовые аспекты и цифровая трансформация медицинских учреждений. Студенты осваивают навыки аналитики, финансового планирования и построения эффективных систем здравоохранения в условиях реформ и международных стандартов.

    Кем можно работать:
    Руководитель медицинского учреждения
    Менеджер по качеству медицинских услуг
    Администратор клиники
    Эксперт в системе обязательного медицинского страхования (ОМС)
    Консультант по медицинской экономике и организационным изменениям

    Зарплата в Европе:
    от €50,000 до €100,000 в год
    в зависимости от должности, страны и уровня учреждения

    Узнайте подробности о стоимости и условиях — оставьте заявку на консультацию! 
  `,
};
